import { render, staticRenderFns } from "./consultBox.vue?vue&type=template&id=d48e57bc&scoped=true"
import script from "./consultBox.vue?vue&type=script&lang=js"
export * from "./consultBox.vue?vue&type=script&lang=js"
import style0 from "./consultBox.vue?vue&type=style&index=0&id=d48e57bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48e57bc",
  null
  
)

export default component.exports